<template>
  <el-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      append-to-body
      title="选择地址"
      class="customer-edit"
      width="80%"
      top="5vh"
      @close="close">
    <vm-table
        ref="vmTable"
        :filter.sync="filter"
        module="basic"
        url="customerDeliveryAddress">
      <div slot="toolbar">
        <el-button type="primary" @click="$refs.editAddCustomer.open(0,filter.customerId)">新建地址</el-button>
      </div>
      <template slot="adSearch">
        <div class="vm-search">
          <vm-search label="所在区域">
            <el-input v-model.trim="filter.addressName" clearable/>
          </vm-search>
          <vm-search label="联系人">
            <el-input v-model.trim="filter.contact" clearable/>
          </vm-search>
          <vm-search label="电话">
            <el-input v-model.trim="filter.telephone" clearable/>
          </vm-search>
        </div>
      </template>
      <el-table-column prop="addressName" align="center" label="所在区域"/>
      <el-table-column prop="addressDetail" align="center" label="详细地址"/>
      <el-table-column prop="contact" align="center" width="60" label="联系人"/>
      <el-table-column prop="telephone" align="center" width="100" label="电话"/>
      <el-table-column prop="isDefault" align="center" width="95" label="是否默认地址">
        <template slot-scope="scope">
          <el-tag>
            {{scope.row.isDefault ? "是":"否"}}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="note" align="center" width="180" label="备注"/>
      <el-table-column label="操作" align="center" width="110px">
        <template slot-scope="scope">
          <el-button type="primary" @click="$refs.editAddCustomer.open(scope.row.pkid,filter.customerId)">编辑</el-button>
          <el-button type="danger" @click="oneDelete(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </vm-table>
    <span slot="footer">
      <el-button @click="close">关闭</el-button>
      <!--<el-button :loading="submitLoading" type="primary" @click="handleSubmit">保存</el-button>-->
    </span>
    <customer-address-edit ref="editAddCustomer" @save-success="getList(1)"/>
  </el-dialog>
</template>

<script>
  import VmTable from "@/components/VmTable.vue";
  import VmSearch from "@/components/VmSearch.vue";
  import constant from "@/util/constant";
  import CustomerAddressEdit from "@/views/information/Customer/CustomerAddressEdit";


  export default {
    name:"CustomerAddress",
    components: {CustomerAddressEdit, VmTable,VmSearch},
    data() {
      return {
        isDefaultTypes: constant.isDefault,
        dialogVisible: false,
        contentLoading: false,
        submitLoading: false,
        idList: "",
        newPkids: [],
        filter: {
          customerId: "",
          addressName: "",
          addressDetail: "",
          contact: "",
          telephone: "",
        },
      };
    },
    methods: {
      open(id) {
        this.dialogVisible = true;
        this.filter.customerId = id;
        this.$nextTick(() => {
          this.getList(1);
        });
      },
      getList(pageNum) {
        this.$refs.vmTable.getList(pageNum);
      },
      close() {
        this.$emit("save-success");
        this.dialogVisible = false;
        this.getList(1);
      },
      // handleSubmit() {
      //   this.newPkids=[];
      //   console.log(this.idList);
      //   for(let item of this.idList) {
      //     this.newPkids.push(item.id);
      //   }
      //   let prams = {
      //     sapMaterialId:this.materials.id,
      //     ids: this.newPkids,
      //   };
      //   console.log(prams);
      //   this.$http
      //     .save("basic", "customerDeliveryAddress",prams)
      //     .then(() => {
      //       this.submitLoading = false;
      //       //this.dialogVisible = false;
      //       this.$message.success("保存成功");
      //       this.idList = [];
      //       this.newPkids = [];
      //     })
      //     .catch(() => {
      //       this.submitLoading = false;
      //     });
      // },
      // 单项删除
      oneDelete(row) {
        this.$confirm("确定删除吗?", "提示", {type: "warning"}).then(() => {
          this.$http
            .delete("basic","customerDeliveryAddress",row.pkid).then(() => {
              this.getList(-1);
              this.$message.success("删除成功");
            });
        });
      },
    },
  };
</script>

<style lang="scss" scoped>
</style>
